import { RepairChartDtoToRepairChart, RepairDetailsDtoToRepairDetails, RepairItensDtoToRepairItens, RepairTableDtoToRepairTable, } from '../../../../mappers/Reports/repair';
import { getCurrentGroupId } from '../../../../utils/functions';
import { api } from '../../api';
export const RepairApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getRepairTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Servicos/${getCurrentGroupId()}`,
                params: {
                    dataInicio: params.startDate || null,
                    dataFim: params.endDate || null,
                    motivo: params.type || null,
                    status: params.status || null,
                    busca: params.term || null,
                    quantidade: params.quantity || 5,
                    pagina: params.page || 1,
                    colunaOrdenacao: params.sorting?.column,
                    direcaoOrdenacao: params.sorting?.direction,
                },
            }),
            transformResponse: (response) => RepairTableDtoToRepairTable(response),
        }),
        getRepairChartData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Servicos/Indicadores/${getCurrentGroupId()}`,
                params: {
                    dataInicio: params.startDate || null,
                    dataFim: params.endDate || null,
                    motivo: params.type || null,
                    dimensao: params.dimension === 'Mês' ? 'Mes' : params.dimension || null,
                },
            }),
            transformResponse: (response) => RepairChartDtoToRepairChart(response),
        }),
        getRepairItensFromId: builder.query({
            query: params => ({
                method: 'get',
                url: `api/Frota/Servicos/${getCurrentGroupId()}/Itens/${params.id}`,
            }),
            transformResponse: (response) => RepairItensDtoToRepairItens(response),
        }),
        getRepairDetailsFromId: builder.query({
            query: params => ({
                method: 'get',
                url: `api/Frota/Servicos/${getCurrentGroupId()}/Detalhes/${params.id}`,
            }),
            transformResponse: (response) => RepairDetailsDtoToRepairDetails(response),
        }),
    }),
});
export const { useGetRepairTableDataQuery, useLazyGetRepairTableDataQuery, useGetRepairChartDataQuery, useLazyGetRepairChartDataQuery, useGetRepairItensFromIdQuery, useLazyGetRepairItensFromIdQuery, useGetRepairDetailsFromIdQuery, useLazyGetRepairDetailsFromIdQuery, } = RepairApi;
